<section class="welcome-dialog">
  <button type="button" class="welcome-close" (click)="close()"
    [attr.aria-label]="'texts.Tutor_Academy_Welcome_Close' | translate">
    <i class="fa-light fa-xmark"></i>
  </button>

  <h2 class="welcome-title" translate>texts.Tutor_Academy_Welcome_Title</h2>
  <p class="welcome-lead" translate>texts.Tutor_Academy_Welcome_Lead</p>

  <div class="welcome-card">
    <div class="welcome-card-icon">
      <i class="fa-regular fa-flag-swallowtail"></i>
    </div>
    <div class="welcome-card-body">
      <span class="welcome-pill welcome-pill-required" translate>texts.Tutor_Academy_Welcome_Pill_Required</span>
      <div class="welcome-card-title" translate>texts.Tutor_Academy_Welcome_Rules_Title</div>
      <p class="welcome-card-text" translate>texts.Tutor_Academy_Welcome_Rules_Text</p>
      <p class="welcome-card-meta">
        <i class="fa-light fa-alarm-clock"></i>
        <span translate>texts.Tutor_Academy_Welcome_Rules_Duration</span>
      </p>
    </div>
  </div>

  <button type="button" class="blue-button welcome-action" (click)="openRulesCourse()">
    <span translate>texts.Tutor_Academy_Welcome_Rules_Button</span>
    <i class="fa-regular fa-arrow-up-right"></i>
  </button>

  <div class="welcome-divider"></div>

  <div class="welcome-academy">
    <div class="welcome-academy-icon">
      <i class="fa-regular fa-book-open"></i>
    </div>
    <div class="welcome-academy-body">
      <div class="welcome-academy-header">
        <span class="welcome-card-title" translate>texts.Tutor_Academy_Welcome_Academy_Heading</span>
        <span class="welcome-pill welcome-pill-optional" translate>texts.Tutor_Academy_Welcome_Pill_Optional</span>
      </div>
      <p class="welcome-card-text" translate>texts.Tutor_Academy_Welcome_Academy_Text</p>
      <p class="welcome-card-text" translate>texts.Tutor_Academy_Welcome_AcademyModules</p>
      <button type="button" class="welcome-link" (click)="openAcademyOverview()">
        <span translate>texts.Tutor_Academy_Welcome_Academy_Link</span>
        <i class="fa-solid fa-arrow-right"></i>
      </button>
    </div>
  </div>

  <p class="welcome-orientation">
    <span translate>texts.Tutor_Academy_Welcome_Orientation</span>
    <span class="welcome-menu-chip">
      <i class="fa-regular fa-book-open"></i>
      <span translate>texts.Tutor_Academy_Welcome_Menu_Label</span>
    </span>
  </p>

  <button type="button" class="welcome-dismiss" (click)="close()" translate>
    texts.Tutor_Academy_Welcome_Dismiss
  </button>
</section>
